module.exports = __webpack_public_path__ + "img/banner-1.a4785427.png";